export default __webpack_public_path__ + "static/media/Awards_IMG-Testimonial-01.8c943de0.png";